import React from 'react'
import * as Immutable from "immutable";
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import {Keys} from '../../model/constants'
import {searchItems} from '../../model/action-creators/item-actions'

import TextField from 'material-ui/TextField'
class AddItemsPage extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            query:""
        };
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    handleKeyUp(event) {

        if (event.keyCode === 27) {
            event.target.value="";
        } else if (event.keyCode === 13) {
            const query = event.target.value;
            console.log("Sending query: "+query);
            if (query.length > 0) {
                this.props.doSearch(query);
            }
        }
    }
    doSearch()  {

    }

    render() {
         return (
            <div>
                <TextField id="search-input" onKeyUp={this.handleKeyUp}/>
                Found:{this.props.searchItemsIds.size} items <br/>
                <ul>
                    {this.props.searchItemsIds.map(i => <li key={i}>{i}</li>)}
                </ul>
            </div>
        )
    }
}
AddItemsPage.propTypes = {
    dispatch:React.PropTypes.func.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    items:ImmutablePropTypes.map.isRequired,
    searchItemIds:ImmutablePropTypes.set.isRequired,
};

const mapSateToProps = (state) => {
    return {
        mutations: state.mutationsState.getIn(Keys.EditorIds.ADD_ITEMS_PAGE, Immutable.Map()),
        items: state.itemsState.get(Keys.StoreSliceData.ITEMS),
        searchItemsIds: state.itemsState.get('searchItemsIds',Immutable.Set()),
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch:dispatch,
        doSearch:(query) => {console.log("Should dispatch searchItems");dispatch(searchItems(query))}
        //doRefreshWorkSessions: () => dispatch(loadWorkSessions()),
        //doLoadWorkSession: (workSessionId) => dispatch(loadCurrentSession(workSessionId)),
        //doCreateAndLoadWorkSession: (templateId, onSuccess) => dispatch(createAndLoadNewSession(templateId, onSuccess)),
    }
};

export default connect(mapSateToProps, mapDispatchToProps)(AddItemsPage);



// WEBPACK FOOTER //
// ./src/ui/pages/AddItemsPage.js